"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_grid_1 = require("@progress/kendo-react-grid");
var kendo_data_query_1 = require("@progress/kendo-data-query");
var kendo_react_excel_export_1 = require("@progress/kendo-react-excel-export");
var CWSRateSearchResults = /** @class */ (function (_super) {
    __extends(CWSRateSearchResults, _super);
    function CWSRateSearchResults(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            sort: [
                { field: 'companyName', dir: 'asc' }
            ],
            skip: 0,
            take: 10
        };
        _this.pageChange = function (event) {
            _this.setState({
                skip: event.page.skip,
                take: event.page.take
            });
        };
        return _this;
    }
    CWSRateSearchResults.prototype.export = function () {
        this._export.save();
    };
    CWSRateSearchResults.prototype.formatRateValue = function (ratevalue) {
        return ratevalue.toFixed(2);
    };
    CWSRateSearchResults.prototype.formatMarketingMethod = function (marketinG_METHOD_CD) {
        var marketingMethod = '';
        if (marketinG_METHOD_CD == "a")
            marketingMethod = " Insurance policies may be purchased through Insurance Agents.";
        else if (marketinG_METHOD_CD == "d")
            marketingMethod = "Insurance policies may be purchased directly from the company.";
        else if (marketinG_METHOD_CD == "n")
            marketingMethod = "Not Marketed";
        else if (marketinG_METHOD_CD == "b")
            marketingMethod = "Insurance policies may be purchased through Insurance Agents or directly from the company.";
        else
            marketingMethod = "unknown";
        return marketingMethod;
    };
    CWSRateSearchResults.prototype.getGridColumns = function () {
        var _this = this;
        var rateCellWidth = 90;
        var rateCellWidthText = '90px';
        var columns = [
            {
                Header: 'Company',
                accessor: 'companyName',
                width: 175,
                locked: true,
                Cell: function (row) { return (React.createElement("td", { colSpan: 1, className: "k-grid-content-sticky", style: { left: '0px', right: '0px', borderRightWidth: '1px' } }, (row.dataItem.companyUrl !== null) ? React.createElement("a", { style: { textDecoration: 'underline' }, href: "http://" + row.dataItem.companyUrl, target: "_blank", rel: "noopener noreferrer" }, row.dataItem.companyName) : row.dataItem.companyUrl)); }
            },
            {
                Header: 'Phone',
                accessor: 'companyPhone',
                width: 125,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: '125px' } }, React.createElement("span", null, row.dataItem.companyPhone))); }
            },
            //{
            //    Header: 'Rating Class',
            //    accessor: 'ratingClass',
            //    width: 125,
            //    locked: false,
            //    Cell: function (row) { return (React.createElement("td", { style: { width: '125px' } }, React.createElement("span", null, row.dataItem.ratingClass))); }
            //},
            {
                Header: 'Marketing Method',
                accessor: 'marketingMethodDesc',
                width: 225,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: '225px' } }, React.createElement("span", null, row.dataItem.marketingMethodDesc))); }
            },
            {
                Header: 'Plan Type',
                accessor: 'groupCode',
                width: 150,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: '150px' } }, React.createElement("span", null, row.dataItem.groupCode))); }
            }
        ];
        var c = { plans: this.props.plans };
        if (c.plans == 'All' || c.plans.indexOf('A') !== -1) {
            columns.push({
                Header: 'A',
                accessor: 'avalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.avalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.aurl) }, _this.formatRateValue(row.dataItem.avalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('B') !== -1) {
            columns.push({
                Header: 'B',
                accessor: 'bvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.bvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.burl) }, _this.formatRateValue(row.dataItem.bvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('C') !== -1) {
            columns.push({
                Header: 'C',
                accessor: 'cvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.cvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.curl) }, _this.formatRateValue(row.dataItem.cvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('D') !== -1) {
            columns.push({
                Header: 'D',
                accessor: 'dvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.dvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.durl) }, _this.formatRateValue(row.dataItem.dvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('F') !== -1) {
            columns.push({
                Header: 'F',
                accessor: 'fvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.fvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.furl) }, _this.formatRateValue(row.dataItem.fvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('G') !== -1) {
            columns.push({
                Header: 'G',
                accessor: 'gvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.gvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.gurl) }, _this.formatRateValue(row.dataItem.gvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('K') !== -1) {
            columns.push({
                Header: 'K',
                accessor: 'kvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.kvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.kurl) }, _this.formatRateValue(row.dataItem.kvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('L') !== -1) {
            columns.push({
                Header: 'L',
                accessor: 'lvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.lvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.lurl) }, _this.formatRateValue(row.dataItem.lvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('M') !== -1) {
            columns.push({
                Header: 'M',
                accessor: 'mvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.mvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.murl) }, _this.formatRateValue(row.dataItem.mvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('N') !== -1) {
            columns.push({
                Header: 'N',
                accessor: 'nvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.nvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.nurl) }, _this.formatRateValue(row.dataItem.nvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('F*') !== -1) {
            columns.push({
                Header: 'F*',
                accessor: 'fstarvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.fstarvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.fstarurl) }, _this.formatRateValue(row.dataItem.fstarvalue)) : 'N/A')); }
            });
        }
        if (c.plans == 'All' || c.plans.indexOf('G*') !== -1) {
            columns.push({
                Header: 'G*',
                accessor: 'gstarvalue',
                width: rateCellWidth,
                locked: false,
                Cell: function (row) { return (React.createElement("td", { style: { width: rateCellWidthText } }, (row.dataItem.gstarvalue !== null) ? React.createElement("a", { href: "#", style: { textDecoration: 'underline' }, onClick: _this.handleRateClicked.bind(_this, row.dataItem.gstarurl) }, _this.formatRateValue(row.dataItem.gstarvalue)) : 'N/A')); }
            });
        }
        var gridColumns = columns.map(function (column) {
            return React.createElement(kendo_react_grid_1.GridColumn, { key: column.accessor, field: column.accessor, title: column.Header, cell: column.Cell, width: column.width, locked: column.locked });
        });
        return gridColumns;
    };
    CWSRateSearchResults.prototype.handleRateClicked = function (rateId, e) {
        e.preventDefault();
        this.props.onHandleRateClicked(rateId);
    };
    CWSRateSearchResults.prototype.render = function () {
        var _this = this;
        var tableData;
        if (this.props.rateDisplays.length > 0) {
            var columns = this.getGridColumns();
            tableData = React.createElement(kendo_react_excel_export_1.ExcelExport, { data: kendo_data_query_1.orderBy(this.props.rateDisplays, this.state.sort), ref: function (exporter) { return _this._export = exporter; } },
                React.createElement(kendo_react_grid_1.Grid, { style: { height: '750px' }, data: kendo_data_query_1.orderBy(this.props.rateDisplays, this.state.sort).slice(this.state.skip, this.state.take + this.state.skip), skip: this.state.skip, take: this.state.take, total: this.props.rateDisplays.length, onPageChange: this.pageChange, pageable: { buttonCount: 4, pageSizes: true }, sortable: true, sort: this.state.sort, onSortChange: function (e) {
                        _this.setState({
                            sort: e.sort
                        });
                    } }, columns));
        }
        else {
            tableData = React.createElement("div", null);
        }
        return tableData;
    };
    return CWSRateSearchResults;
}(React.PureComponent));
;
exports.default = CWSRateSearchResults;
//# sourceMappingURL=CWSRateSearchResults.js.map